"use client";

import { useEffect, useState, useCallback } from "react";
import { MeiliSearchVehicleType } from "../../../../types/Vehicle.types";
import { meiliSearchClient } from "../../../../meiliseach/client";
import { MeiliSearchResponse } from "../../../../hooks/meilisearch/useAutocomplete/props";
import { VehicleCard } from "../../../vehicle/card";
import { Pagination } from "@saas/shared/components/Pagination";
import { Search } from "lucide-react";

export const SellerVehicleList = ({ sellerId }: { sellerId: string }) => {
  const [query, setQuery] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalHits, setTotalHits] = useState<number>(0);
  const [vehicles, setVehicles] = useState<MeiliSearchVehicleType[] | null>(
    null
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const ITEMS_PER_PAGE = 15;

  const fetchHits = useCallback(
    async (currentPage: number, searchQuery: string) => {
      setIsLoading(true);
      try {
        const index = meiliSearchClient.index("vehicles");
        const response: MeiliSearchResponse = await index.search(searchQuery, {
          filter: `teamId = ${sellerId}`,
          page: currentPage,
          hitsPerPage: ITEMS_PER_PAGE,
        });

        setVehicles(response.hits);
        setTotalHits(response.totalHits || 0);
      } catch (error) {
        console.error("Erro ao buscar veículos:", error);
        setVehicles([]);
      } finally {
        setIsLoading(false);
      }
    },
    [sellerId]
  );

  useEffect(() => {
    let isMounted = true;

    const updateHits = async () => {
      await fetchHits(page, query);
    };

    if (isMounted) {
      updateHits();
    }

    return () => {
      isMounted = false;
    };
  }, [page, query, fetchHits]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  return (
    <section className="mt-6 border-b border-gray-200 pb-20">
      <h3 className="mb-5 font-medium text-xl tracking-wide">Estoque</h3>

      <div className="ais-SearchBox-input w-full bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 rounded-md focus:ring-1 flex items-center relative !pl-0 overflow-hidden mb-5">
        <Search color="#6b6464" size={17} className="absolute top-3 left-3" />
        <input
          className="border-none w-full pl-[2.5rem] text-sm rounded-[3px] shadow-inner py-2.5"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Busque seu novo veículo"
        />
      </div>

      {isLoading ? (
        <div className="w-full flex justify-center min-h-96">
          <span className="text-gray-500">Carregando...</span>
        </div>
      ) : vehicles && vehicles.length > 0 ? (
        <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 items-stretch">
          {vehicles.map((vehicle, index) => (
            <VehicleCard key={`vehicle-${vehicle.id}-${index}`} hit={vehicle} />
          ))}
        </div>
      ) : (
        <div className="w-full flex justify-center min-h-96">
          <span className="w-full text-sm text-center text-gray-500">
            Esse vendedor ainda não possui um estoque
          </span>
        </div>
      )}

      <div className="flex gap-5 w-full items-center justify-center py-5">
        <Pagination
          currentPage={page}
          itemsPerPage={ITEMS_PER_PAGE}
          onChangeCurrentPage={handlePageChange}
          totalItems={totalHits}
        />
      </div>
    </section>
  );
};
